module.exports = "/_next/static/images/cenk-b897c02d0521f7f7fbda8d3af5d41ff4.png";